import React from "react";
import Header from "components/Admin/shared/Table/Header.jsx";

const titles = {
  start_date: "START DATE/TIME",
  webinar_title: "TITLE",
  cpd_points: "CPD POINTS",
  status: "STATUS",
};

const additionalProps = {
  start_date: {
    revert: true,
  },
  status: {
    thProps: {
      colSpan: "2",
    },
  },
};

function Headers({ onChange, value: selectedValue }) {
  return (
    <tr>
      <th></th>
      {Object.keys(titles).map((value) => (
        <Header
          onChange={onChange}
          key={value}
          values={[value]}
          title={titles[value]}
          selected={selectedValue}
          {...(additionalProps[value] || {})}
        />
      ))}
    </tr>
  );
}

Headers.defaultProps = {};

Headers.propTypes = {};

export default Headers;



// WEBPACK FOOTER //
// ./src/components/Admin/ClientUrls/AddWebinars/Headers.jsx